import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HttpClientModule} from '@angular/common/http';
import {StoreModule} from '@ngrx/store';
import * as fromPermission from './+state/permission.reducer';
import {EffectsModule} from '@ngrx/effects';
import {PermissionEffects} from './+state/permission.effects';
import {NGXLogger} from 'ngx-logger';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    HttpClientModule,
    StoreModule.forFeature(
      fromPermission.PERMISSION_FEATURE_KEY,
      fromPermission.reducer
    ),
    EffectsModule.forFeature([PermissionEffects]),
  ]
})
export class PermissionStoreModule {

  constructor(private logger: NGXLogger) {
    logger.trace('*---------------------------------------------------------------------*');
    logger.trace('*', this.constructor.name, 'Loaded');
    logger.trace('*---------------------------------------------------------------------*');
  }

}
